import React from "react";
import styled from "styled-components"

const LogoImage = styled.img`
    max-width: 250px;
`

export default LogoImage


// WEBPACK FOOTER //
// ./src/views/Auth/components/LogoImage/index.jsx